/* global __APP_VERSION__ */
import { ref } from 'vue';

const updateAvailable = ref(false);

export function useVersionCheck() {
    async function checkForUpdate() {
        if (import.meta.env.DEV) return;

        try {
            const res = await fetch('/version.json?_t=' + Date.now(), {
                cache: 'no-store',
            });

            if (!res.ok) return;

            const data = await res.json();

            if (data.version && data.version !== __APP_VERSION__) {
                updateAvailable.value = true;
            }
        } catch {
            // network error — ignore silently
        }
    }

    function reloadForUpdate() {
        sessionStorage.setItem('reloadNotification', true);
        window.location.reload();
    }

    return { updateAvailable, checkForUpdate, reloadForUpdate };
}
